import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';
import RepayDate from '../repaymentSummaryItem/RepayDate';
import RepayDescription from '../repaymentSummaryItem/RepayDescription';
import RepayLabel from '../repaymentSummaryItem/RepayLabel';
import RepaymentSummaryItem from '../repaymentSummaryItem/RepaymentSummaryItem';
import RepayMoney from '../repaymentSummaryItem/RepayMoney';
import messages from './NextRepaymentSummary.messages';

class NextRepaymentSummary extends Component {
    renderDescription() {
        const { previousNextRepayment } = this.props;

        if (previousNextRepayment) {
            return (
                <FormattedMessage
                    {...messages.reducedDescription}
                    values={{
                        amount: (
                            <FormattedCurrency value={previousNextRepayment} />
                        )
                    }}
                />
            );
        }

        return <FormattedMessage {...messages.sameDescription} />;
    }

    render() {
        const { interval, date, amount } = this.props;
        const description = this.renderDescription();

        return (
            <RepaymentSummaryItem>
                <RepayLabel>
                    <FormattedMessage {...messages.label} />
                </RepayLabel>
                <RepayMoney value={amount} />
                <RepayDate interval={interval} value={date} />
                <RepayDescription>{description}</RepayDescription>
            </RepaymentSummaryItem>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default NextRepaymentSummary;
